<template>
  <div class="wrapper-content w-100">
    <h1>{{ title }}</h1>
    <LmBreadcrumb v-if="showBreadcrumb" />
    <LmForm ref="lmFormRef">
      <div class="row">
        <LmTextInput class="col-12" v-model="form.title" label="Título" :v="$v.form.title" />
      </div>
      <div class="row">
        <LmEditor ref="lmEditorSeccionVisto" class="col-12" @onUpdate="form.content = $event" label="Contenido"
          :v="$v.form.content" :contentProps="form.content" :activeTable="false" />
      </div>
      <div class="mt-2 mb-4 bg-light px-4 pt-4 pb-3">
        <LmButton type="button" buttonClass="btn btn-outline-primary" :isProcessing="formIsProcessing"
        :value="$t('Agregar Item')" @click.native="agregarItem()" lmButtonRootWrapperClass="d-inline-block"
        lmButtonWrapperClass="col" />
        <div v-for="(item, index) in form.items" :key="`${item.title}-${index}`">
          <b-card class="mb-3">
            <button v-b-toggle="`collapse-${index}`" class="bg-white border-0 p-0 m-0">
              {{ item.title }}
              <font-awesome-icon
                    id="angle-down"
                    icon="angle-down"
                    size="lg"
                    class=" ml-1"

                  />

              </button>
              <button class="bg-white border-0 p-0 m-0 float-right" @click="removeItem(index)">
                <font-awesome-icon
                      id="trash"
                      icon="trash"
                      size="lg"
                    />
              </button>
              <b-collapse :id="`collapse-${index}`" class="mt-4">
              <LmTextInput :value="item.title" label="Título" @input="updateRepeatFields(index,'title', $event)" :ref="`title-${index}`" />
              <LmEditor label="Contenido"  :contentProps="item.content" :activeTable="true" :activeImageUpload="false" class="p-0 m-0" @onUpdate="updateRepeatFields(index,'content', $event)"/>
              </b-collapse>
            </b-card>
        </div>
      </div>
      <LmButton id="btn-cancel" type="button" buttonClass="btn-secondary" :isProcessing="formIsProcessing"
        :value="$t('Cancel')" @click.native="cancelBtn" lmButtonRootWrapperClass="d-inline-block mr-1"
        lmButtonWrapperClass="col" />
      <LmButton type="submit" buttonClass="btn-success" :isProcessing="formIsProcessing" :value="$t('Save')"
        lmButtonRootWrapperClass="d-inline-block mr-1" lmButtonWrapperClass="col" @click.native="submit('guardar')" />
      <LmButton type="submit" buttonClass="btn-primary" :isProcessing="formIsProcessing" :value="$t('Guardar y salir')"
        lmButtonRootWrapperClass="d-inline-block mr-1" lmButtonWrapperClass="col"
        @click.native="submit('guardarSalir')" />
    </LmForm>
  </div>
</template>

<script>
import store from '@/store'
import axios from 'axios'

import LmForm from '@/components/form/LmForm.vue'
import LmTextInput from '@/components/form/elements/LmTextInput'
import { required } from 'vuelidate/lib/validators'
import LmEditor from '@/components/LmEditor.vue'
import LmButton from '@/components/form/elements/LmButton.vue'
import LmUploadFiles from '@/components/LmUploadFiles'
import LmImagenPages from '@/views/365/pages/elements/LmImagenPages'

export default {
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      form: {
        title: '',
        content: '',
        image_url: '',
        items: []
      },
      timeout: null,
      formIsProcessing: false,
      files: []
    }
  },
  validations: {
    form: {
      title: {
        required
      },
      content: {
        required
      },
      image_url: {
        required
      }
    }
  },
  components: {
    LmForm,
    LmTextInput,
    LmEditor,
    LmButton,
    LmUploadFiles,
    LmImagenPages
  },
  methods: {
    removeItem (index) {
      this.form.items.splice(index, 1)
    },
    agregarItem () {
      this.form.items.push(
        {
          title: 'Título',
          content: 'Contenido...',
          urlimagen: ''
        }
      )
    },
    updateRepeatFields (index, key, event) {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.form.items[index][key] = event
      }, 1000)
    },
    async submit (guardarType) {
      try {
        await this.$refs.lmFormRef.validationForm(this.$v)
        this.formIsProcessing = true
        const fileLoaded = this.files.length ? this.files[0].path : ''
        const dataToSendToTheServer = {
          title: this.form.title,
          content: this.form.content,
          items: JSON.stringify(this.form.items),
          urlimagen: fileLoaded || this.form.image_url
        }

        await axios.post(
          `${process.env.VUE_APP_API_URL}pages/edit-reglamento/`,
          dataToSendToTheServer,
          {
            headers: {
              Authorization: `Bearer ${store.state.session.accessToken}`
            }
          }
        )

        if (guardarType === 'guardarSalir') {
          this.$router.go(-1)
        } else {
          this.makeToast('guardar')
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.formIsProcessing = false
      }
    },
    makeToast (variant = null) {
      if (variant === 'guardar') {
        this.$bvToast.toast('El contenido se guardó exitosamente.', {
          title: `Mensaje`,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-center'
        })
      }
    },
    cancelBtn () {
      this.$router.go(-1)
    },
    fileCreatedd (file, response) {
      if (response) {
        this.form.image_url = response.path
        this.files.push(response)
      }
      this.$refs.lmUploadFiles.disable()
    },
    fileCreated (file, response) {
      if (response) {
        setTimeout(() => {
          this.options.idRandom = Math.random()
        }, 1000
        )
        this.form.image_url = response.path
        this.options.image = response.path
        this.options.imageOriginalName = response.originalname
        this.options.imageSize = this.bytesToSize(response.size)

        this.files.push(response)
      }
      this.$refs.lmUploadFiles.disable()
    },
    fileRemovedd (file, error, xhr) {
      this.form.image_url = ''
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFiles.enable()
    },
    fileRemoved (file, error, xhr) {
      this.form.image_url = ''
      this.options.image = ''
      this.files = []
      if (file) {
        this.files = this.files.filter(f => f.originalname !== file.name)
      }
      this.$refs.lmUploadFiles.lmRemoveAllFiles()
      this.$refs.lmUploadFiles.enable()
    },
    bytesToSize (bytes) {
      const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
    },
    async setForm () {
      await this.$refs.lmFormRef.activeEditMode({
        path: 'pages/read-reglamento/'
      })
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    }

  },
  mounted () {
    this.setForm()
  }
}

</script>
<style scope lang="css">
.editor-tiptap a {
  color: #f03d37;
}
.editor-tiptap ul {

  margin-left: 15px;
}

.editor-tiptap dl, .editor-tiptap ol {
  padding-left: 30px;
}
.editor-tiptap table, .editor-tiptap tr, .editor-tiptap td {
  border: 1px solid;
  padding: 5px;
}
.editor-tiptap blockquote {
  font-size: 14px;
  padding: 8px 14px 1px 14px;
  border-left: 3px solid #f03d37;
  margin-top: 10px;
}
</style>
